import cx from "classnames";

import { Incognito, Network } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import {
  PUBLIC_WORKER_POOL_NAME,
  PUBLIC_WORKER_POOL_URL,
} from "views/Account/WorkerPool/constants";

import { WorkerPoolsTableRow } from "../types";
import styles from "./styles.module.css";

const WorkerPoolsTableNameCell = ({
  item: row,
  ...cellProps
}: TableSimpleCellProps<WorkerPoolsTableRow>) => {
  if (row.kind === "public") {
    return (
      <TableSimpleCell {...cellProps} role="rowheader">
        <Box direction="row" align="center" gap="large">
          <Box
            direction="row"
            align="center"
            justify="center"
            className={cx(styles.workerTypeIcon, styles.publicWorkerTypeIcon)}
          >
            <Icon noShrink size="large" src={Network} />
          </Box>
          <TableCellLink className={styles.nameLink} href={`${PUBLIC_WORKER_POOL_URL}/queue`}>
            {PUBLIC_WORKER_POOL_NAME}
          </TableCellLink>
        </Box>
      </TableSimpleCell>
    );
  }

  const { workerPool } = row;

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <Box direction="row" align="center" gap="large">
        <Box direction="row" align="center" justify="center" className={styles.workerTypeIcon}>
          <Icon noShrink size="large" src={Incognito} />
        </Box>
        <TableCellLink className={styles.nameLink} href={`/worker-pool/${workerPool.id}`}>
          {workerPool.name}
        </TableCellLink>
      </Box>
    </TableSimpleCell>
  );
};

export default WorkerPoolsTableNameCell;
